namespace TabAurous.Purchase {
    export namespace PurchaseApprovalItemsService {
        export const baseUrl = 'Purchase/PurchaseApprovalItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/PurchaseApprovalItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PurchaseApprovalItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
